<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    export default {
        name: 'ScrollableContainer',
    };
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    const props = defineProps<{
        containerClasses?: string;
        containerStyles?: string;
    }>();
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <div class="scrollable-wrapper" data-type="containerwrapper">
        <div class="scrollable-container" data-type="container" :class="containerClasses" :style="containerStyles">
            <slot />
        </div>
    </div>
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style>
    .scrollable-wrapper::-webkit-scrollbar {
        width: 0.45rem;

        /* width: 0; */
    }
    .scrollable-wrapper::-webkit-scrollbar-track {
        background-color: none;
    }
    .scrollable-wrapper::-webkit-scrollbar-thumb {
        /* background-color: #c8c8c88c; */
        /* border: 4px solid red; */
        /* border: .2rem solid transparent; */
        box-shadow: inset 0 0 0 20px;
        border-radius: 1rem;
    }
    .page-wrapper .scrollable-wrapper::-webkit-scrollbar {
        width: 0.66rem;

        /* width: 0; */
    }
    .page-wrapper .scrollable-wrapper,
    .page-wrapper .scrollable-wrapper:hover {
        color: rgb(180, 180, 180);
    }

    .scrollable-wrapper {
        display: block;
        position: relative;
        height: 100%;
        padding-right: 0.175rem;
        margin-right: 0.2rem;
        overflow-y: auto;

        color: transparent;
        transition: color 0.3s ease;
    }
    .scrollable-wrapper:hover {
        color: black;
        color: var(--clr-mirage);
        /* color: rgb(202, 202, 202); */
    }
    .scrollable-container {
        color: initial;
    }

    .scrollable-wrapper.xs-white-space {
        padding-right: 0;
        margin-right: 0.1rem;
    }

    .scrollable-wrapper.grey:hover {
        color: rgb(148, 163, 161);
    }

    .standard-overflow {
        overflow: auto;
    }
</style>
